import { reflectKeys } from "@utils/key.reflactor";

export const DEFAULT_EXPIRY_YEAR_OFFSET = 10;
export const DEFAULT_EXPIRY_YEAR_OFFSET_ADMIN = 12;

export const GROUP_TYPE = {
  SUBJECT_GROUP: "SUBJECT_GROUP",
  TEACHING_GROUP: "TEACHING_GROUP",
  COMMUNITY: "COMMUNITY",
};

export const STUDENTS_IN_GROUP_SELECTED = {
  ALL: "All students and teachers",
  SELECTED_RECIPIENTS: "Selected Recipients",
};

export const ROLE_IN_GROUP = reflectKeys([
  "GROUP_OWNER",
  "CO_TEACHER",
  "LIAISON_TEACHER",
  "STUDENT",
  "OBSERVER",
]) as {
  GROUP_OWNER: string;
  CO_TEACHER: string;
  LIAISON_TEACHER: string;
  STUDENT: string;
  OBSERVER: string;
};

export const ROLE_IN_GROUP_LABEL = {
  GROUP_OWNER: "Owner",
  CO_TEACHER: "Co-Teacher",
  OBSERVER: "Observer",
  LIAISON_TEACHER: "Liaison Teacher",
};

export const NAMESPACE = {
  AUTH: "auth",
};

export const MAX_LENGTH = {
  GROUP_NAME: 50,
};

export const ERROR_CODE = {
  DUPLICATED_NAME: "duplicated-name",
  ABSENT_TEACHER: "absent-teacher",
  NO_OWNER: "teaching.group.with.no.owner",
  ACCESS_DENIED: "access-denied",
};

export const GROUP_FUNCTION_TYPE_OPTIONS = {
  STUDENT: {
    label: "student_group_group_detail_subpage_groupfunctiontype_student_option_label",
    value: "STUDENT",
  },
  STAFF: {
    label: "student_group_group_detail_subpage_groupfunctiontype_staff_option_label",
    value: "STAFF",
  },
  PROFESSIONAL_DEVELOPMENT: {
    label: "student_group_group_detail_subpage_groupfunctiontype_pd_option_label",
    value: "PROFESSIONAL_DEVELOPMENT",
  },
  COMMUNITY: {
    label: "student_group_group_detail_subpage_groupfunctiontype_community_option_label",
    value: "COMMUNITY",
  },
};

export const FILE_SIZE_LIMIT = "10";
